import React from 'react';
import { Link } from 'react-router-dom';

export default function AdditionLogo() {
  return (
    <Link to="/" className="flex items-center">
      <img
        src="/images/ADDITION-logo.png"
        alt="Addition Credit Union"
        className="h-14 md:h-16 lg:h-20 w-auto max-w-[320px] transition-all duration-300"
      />
    </Link>
  );
} 